import { render } from "./TermsAndPrivacyEcommerce.vue.ts?vue&type=template&id=04bdbf56&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyEcommerce.vue?vue&type=template&id=04bdbf56&scoped=true&ts=true"
import script from "./TermsAndPrivacyEcommerce.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyEcommerce.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsAndPrivacyEcommerce.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyEcommerce.vue?vue&type=script&setup=true&lang=ts"

import "./TermsAndPrivacyEcommerce.vue.scss?vue&type=style&index=0&id=04bdbf56&lang=scss&scoped=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyEcommerce.vue?vue&type=style&index=0&id=04bdbf56&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bdbf56"],['__file',"src/apps/merchant3/components/customer-registration/terms-and-privacy/TermsAndPrivacyEcommerce.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04bdbf56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04bdbf56', __exports__)) {
    api.reload('04bdbf56', __exports__)
  }
  
  module.hot.accept("./TermsAndPrivacyEcommerce.vue.ts?vue&type=template&id=04bdbf56&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyEcommerce.vue?vue&type=template&id=04bdbf56&scoped=true&ts=true", () => {
    api.rerender('04bdbf56', render)
  })

}


export default __exports__